export default __webpack_public_path__ + "static/media/prod3.bbdfb1d1.png";